import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const StepDetails = ({ formData, updateFormData }) => (
  <div className="space-y-6">
    <div className="text-center mb-6">
      <h2 className="text-xl font-semibold text-gray-900">Your Details</h2>
      <p className="text-sm text-gray-500 mt-1">Tell us a bit about yourself</p>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="name">Full Name *</Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => updateFormData('name', e.target.value)}
          placeholder="John Smith"
          data-testid="input-name"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="email">Email Address *</Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => updateFormData('email', e.target.value)}
          placeholder="john@example.com"
          data-testid="input-email"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="phone">Phone Number *</Label>
        <Input
          id="phone"
          value={formData.phone}
          onChange={(e) => updateFormData('phone', e.target.value)}
          placeholder="07123 456789"
          data-testid="input-phone"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="postcode">Postcode *</Label>
        <Input
          id="postcode"
          value={formData.postcode}
          onChange={(e) => updateFormData('postcode', e.target.value.toUpperCase())}
          placeholder="SW1A 1AA"
          data-testid="input-postcode"
        />
      </div>
    </div>
  </div>
);

export default StepDetails;
